module.exports = __webpack_public_path__ + "static/media/highlight_2x.17613b9d.png";